import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {UserDataService} from "../user-data.service";
import {Observable} from "rxjs";

@Injectable()
export class UserRoleGuardService implements CanActivate {

    private userRole: any;

    constructor(private auth: UserDataService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // save expected roles from route
        const expectedRoles = route.data.expectedRoles;

        // check user roles and verify if includes expected roles, returns true or false
        return this.auth.getMainData().toPromise().then( res => {
            this.userRole = res['roles'];

            const intersection = expectedRoles.filter(element => this.userRole.includes(element));

            if (intersection.length === 0) {
                this.router.navigate(['/autentificare']);
                return false;
            }

            return true;

        }, error => this.router.navigate(['/autentificare']));
    }

}
